"use client";

import { Children } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Fade, Scrollable } from "@churchofjesuschrist/eden-fade";
import PlatformModal from "@churchofjesuschrist/eden-platform-modal";
import { jsx as _jsx } from "react/jsx-runtime";
const Dialog = styled(PlatformModal).withConfig({
  componentId: "sc-1w2izfe-0"
})(["border:0;"]);
const noop = x => x;

/**
 * Displays an alert notification within a modal/Dialog.
 */
const Modal = ({
  open,
  children,
  ...props
}) => {
  const {
    onClose = noop
  } = Children.toArray(children)[0].props;
  return /*#__PURE__*/_jsx(Dialog, {
    open: open,
    onClose: onClose,
    ...props,
    children: /*#__PURE__*/_jsx(Fade, {
      children: /*#__PURE__*/_jsx(Scrollable, {
        children: children
      })
    })
  });
};
Modal.displayName = "Modal";
Modal.propTypes = {
  /** Must be a single `<Alert>`, `<Error>`, `<Info>`, `<Success>`, or `<Warn>` element from `eden-alert` to display in the modal. */
  children: PropTypes.node.isRequired,
  /** Whether modal is open */
  open: PropTypes.bool
};
export default Modal;